export var nl = {
    required: 'Vereist',
    deprecated: 'Verouderd',
    deprecated_and_sunset_on: 'Deze bewerking is verouderd en wordt op ${1} beëindigd.',
    stability_experimental: 'Experimenteel',
    stability_alpha: 'Alfa',
    stability_beta: 'Bèta',
    copy_to_clipboard: 'Kopiëren naar klembord',
    copied: 'Gekopieerd',
    no_content: 'Geen inhoud',
    unresolved_reference: 'Onopgeloste verwijzing',
    circular_reference: 'Circulaire verwijzing',
    read_only: 'Alleen lezen',
    write_only: 'Alleen schrijven',
    optional: 'Optioneel',
    min: 'Min',
    max: 'Max',
    nullable: 'Null toegestaan',
    body: 'Body',
    payload: 'Payload',
    headers: 'Headers',
    authorizations: 'Autorisaties',
    responses: 'Reacties',
    path_parameters: 'Padparameters',
    query_parameters: 'Queryparameters',
    header_parameters: 'Headerparameters',
    attributes: 'Attributen',
    test_it: 'Test het',
    information: 'Informatie',
    success: 'Succes',
    redirect: 'Omleiding',
    error: 'Fout',
    show: 'Toon',
    hide: 'Verbergen',
    available_items: 'Beschikbare items',
    child_attributes: 'Kindattributen',
};
